'use strict';

import template from './template.html';


export default function() {
	return {
		require: '^incident',
		template: template,
		link: {
			pre: preLink,
		},
		scope: {
			name: '@',
			description: '@',
			event: '@',
			message: '@',
			label: '@',
		}
	}

	// This is a bit of a hack to make the incident available in postLink
	// functions.  In particular, the brgRestForm seems to link before this
	// directive, which then incorrectly parses the action because the incident
	// is not yet available.  This fixes that issue.
	function preLink(scope, element, attrs, $incident) {
		scope.$incident = $incident;
	}
}
